// Set log level if development mode
if (window.Shopify?.theme.role === 'development') {
  log.setLevel(log.levels.TRACE, false);
}

// Log cart value
const cartLogger = () => {
  log.debug('🛍️ Cart', window.liquidAjaxCart.cart);

  if (window.cartRefreshOnFocus !== undefined) {
    window.liquidAjaxCart.conf('updateOnWindowFocus', window.cartRefreshOnFocus);

    log.debug('liquidAjaxCart configs:', {
      updateOnWindowFocus: window.cartRefreshOnFocus,
    });
  }
};

if (window.liquidAjaxCart?.init) {
  cartLogger();
} else {
  document.addEventListener('liquid-ajax-cart:init', cartLogger);
}

class CollectionLinkManager {
  constructor() {
    this.AVAILABILITY_PARAM = 'filter.v.availability';
    this.AVAILABILITY_VALUE = '1';
    this.isEnabled = false;
    this.init();
  }

  init() {
    this.checkSetting();

    if (!this.isEnabled) {
      return;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  checkSetting() {
    if (window.Shopify?.theme?.settings?.auto_filter_in_stock) {
      this.isEnabled = true;
    } else if (window.themeSettings?.auto_filter_in_stock) {
      this.isEnabled = true;
    } else {
      this.isEnabled = window.autoFilterInStock === true;
    }
  }

  setup() {
    this.processExistingLinks();
    this.observeNewLinks();
  }

  hasAvailabilityFilter(url) {
    const urlObj = new URL(url, window.location.origin);
    return urlObj.searchParams.has(this.AVAILABILITY_PARAM);
  }

  addAvailabilityFilter(url) {
    const urlObj = new URL(url, window.location.origin);

    if (!this.hasAvailabilityFilter(url)) {
      urlObj.searchParams.set(this.AVAILABILITY_PARAM, this.AVAILABILITY_VALUE);
    }

    return urlObj.pathname + urlObj.search + urlObj.hash;
  }

  processExistingLinks() {
    const collectionLinks = document.querySelectorAll('a[href*="/collections"]');

    collectionLinks.forEach(link => {
      const originalHref = link.getAttribute('href');
      if (originalHref && originalHref.includes('/collections')) {
        const updatedHref = this.addAvailabilityFilter(originalHref);
        if (updatedHref !== originalHref) {
          link.setAttribute('href', updatedHref);
        }
      }
    });
  }

  observeNewLinks() {
    if (!window.MutationObserver) {
      return;
    }

    const observer = new MutationObserver(mutations => {
      let hasNewLinks = false;

      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.tagName === 'A' && node.href && node.href.includes('/collections')) {
              hasNewLinks = true;
            } else if (node.querySelectorAll) {
              const collectionLinks = node.querySelectorAll('a[href*="/collections"]');
              if (collectionLinks.length > 0) {
                hasNewLinks = true;
              }
            }
          }
        });
      });

      if (hasNewLinks) {
        clearTimeout(this.processTimeout);
        this.processTimeout = setTimeout(() => {
          this.processExistingLinks();
        }, 50);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

const _collectionLinkManager = new CollectionLinkManager();
